import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { BiLinkExternal } from "react-icons/bi";
import ProjectsCarousel from "./Carousel";
import { Link } from "react-router-dom";
import {
  slideInRight,
  bounceIn,
  slideInLeft,
  slideInUp,
  slideInDown,
} from "react-animations";
import Radium, { StyleRoot } from "radium";

function ProjectCards(props) {
  const styles = {
    slideInLeft: {
      animation: "x 3s",
      animationName: Radium.keyframes(slideInLeft, "bounce"),
    },
    slideInUp: {
      animation: "x 3s",
      animationName: Radium.keyframes(slideInUp, "bounce"),
    },
    slideInRight: {
      animation: "x 3s",
      animationName: Radium.keyframes(slideInRight, "bounce"),
    },
    bounceIn: {
      animation: "x 3s",
      animationName: Radium.keyframes(bounceIn, "bounce"),
    },
    slideInDown: {
      animation: "x 3s",
      animationName: Radium.keyframes(slideInDown, "bounce"),
    },
  };
  return (
    <StyleRoot>
      <Card className="project-card-view">
        {/* <Card.Img variant="top" src={props.imgPath} alt="card-img" /> */}
        <div style={styles.slideInLeft}>
          <ProjectsCarousel

            home={props.home}
            about={props.about}
            manage={props.manage}
            add={props.add}
          ></ProjectsCarousel>
        </div>
        <div style={styles.slideInUp}>
          <Card.Body >
            <Card.Title>{props.title}</Card.Title>
            <Card.Text style={{ textAlign: "justify" }}>
              {props.description}
            </Card.Text>
            <Button variant="info" href={props.link} target="_blank">
              <BiLinkExternal /> &nbsp;
              {props.isBlog ? "View Blog" : "View Project"}
            </Button>
            <Button style={{ marginLeft: '2px' }} variant="info" href={props.gitlink} target="_blank">
              <BiLinkExternal /> &nbsp;
              {props.isBlog ? "View Blog" : "GitHub"}
            </Button>
            <Link to={props.path}><Button style={{ marginTop: '10px' }} variant='info'>Details</Button> </Link>
          </Card.Body>
        </div>

      </Card>
    </StyleRoot>
  );
}
export default ProjectCards;
